import React from 'react';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Detail } from '../pages/detail';
import { Search } from '../pages/search';

const jobRoutes = JSON.parse(process.env.REACT_APP_BASE_URL!); 

const Router = () => {
  const getBaseName = () => {
    const currentPath = window.location.pathname;
    return jobRoutes.find((jobRoute : string) => currentPath.startsWith(jobRoute));
  };

  const basename = getBaseName();

  return basename ? 
    (
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="" element={<Search />} />
          <Route path="/:id" element={<Detail />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    ) : (<></>);

};

export default Router;
